import { RestMethod } from "app/_helpers/ApiConfig/RestMethod";
import toastr from "toastr";
// import { RestMethod } from '../../_helpers/ApiConfig/RestMethod'
// import FilterResponse from '../../_helpers/FilterResponse'
// import toastr from 'toastr'

export const SupportService = {
  reOpen,
  getSupport,
  getSupportByID,
  getSupportByUserId,
  createSupport,
  updateSupport,
  deleteSupport,
  getSupportModule,
  closeSupport,
  getChatBySupportID,
  getChatByID,
  createChat,
  ticketHistory,
};
async function ticketHistory(data) {
  try {
    const response = await RestMethod.POST("/support/ticket-history", data);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function getSupport(projectID) {
  try {
    const response = await RestMethod.GET("/support");
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function getSupportByID(id) {
  try {
    const response = await RestMethod.GET("/support/" + id);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function getSupportByUserId(id) {
  try {
    const response = await RestMethod.GET("/support/user" + id);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function createSupport(data) {
  try {
    const response = await RestMethod.POST("/support", data);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function updateSupport(id, data, userId = "") {
  try {
    if (userId === data.assignedTo) {
      toastr.error("You Can't Assign Ticket To Yourself");
      return;
    }
    const response = await RestMethod.PUT("/support/" + id, data);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function closeSupport(id, data) {
  try {
    const response = await RestMethod.PUT("/support/close/" + id, data);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}
async function deleteSupport(id, data) {
  try {
    const response = await RestMethod.DELETE("/support/" + id, data);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}
async function reOpen(id, data) {
  try {
    const response = await RestMethod.PUT("/support/reopen/" + id, data);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function getSupportModule() {
  try {
    const response = await RestMethod.GET("/common/module");
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function getChatBySupportID(supportID) {
  try {
    const response = await RestMethod.GET("/support/" + supportID + "/chat");
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function getChatByID(supportID, id) {
  try {
    const response = await RestMethod.GET("/support/" + supportID + "/chat/" + id);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function createChat(supportID, data) {
  try {
    const response = await RestMethod.POST("/support/" + supportID + "/chat", data);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}
